(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterColumnGrid extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.setMaxChildHeight();

      // Use ResizeObserver for better performance
      this.resizeObserver = new ResizeObserver(() => {
        this.setMaxChildHeight();
      });

      // Observe all direct children for size changes
      Array.from(this.children).forEach((child) => {
        this.resizeObserver.observe(child);
      });
    }

    disconnectedCallback() {
      // Clean up observer when element is removed
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    setMaxChildHeight() {
      // Get all direct children
      const children = Array.from(this.querySelectorAll('.footercolumn-grid > .footer-block--wrapper'));

      if (children.length === 0) return;

      const grid = children[0].parentElement;
      const heights = children.map((child) => child.offsetHeight);
      const maxHeight = Math.max(...heights);

      // How many block columns fit side by side (4 on desktop, 3 on tablet)
      const gridStyle = getComputedStyle(grid);
      const gridWidth = grid.clientWidth - parseFloat(gridStyle.paddingLeft) - parseFloat(gridStyle.paddingRight);
      const columns = Math.max(1, Math.round(gridWidth / children[0].offsetWidth));

      // Count the columns the flex column wrap creates for a given height cap
      const columnsNeeded = (cap) => {
        let count = 1;
        let used = 0;
        heights.forEach((height) => {
          if (used > 0 && used + height > cap) {
            count += 1;
            used = 0;
          }
          used += height;
        });
        return count;
      };

      // Pick the smallest cap that packs every block into the available columns,
      // so the footer never wraps a block into a column past the right edge
      const caps = [];
      for (let start = 0; start < heights.length; start++) {
        let sum = 0;
        for (let end = start; end < heights.length; end++) {
          sum += heights[end];
          if (sum >= maxHeight) caps.push(sum);
        }
      }
      caps.sort((a, b) => a - b);
      const cap = caps.find((candidate) => columnsNeeded(candidate) <= columns) || heights.reduce((a, b) => a + b, 0);

      // max-height also includes the grid's 1px top and bottom borders
      this.style.setProperty('--max-child-height', `${cap + 2}px`);
    }
  }

  customElements.define('footercolumn-grid', FooterColumnGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
